module.exports = "/images/Ukraine.png?b2407da0e0fa89b2c09d6195f4c94cd3";